<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-content " @click.stop>
      <button class="close-btn" @click="closeModal">✖</button>
      <h3 class="modal-title">{{ title }}</h3>
      <div class="modal-body">
        <p class="modal-text" v-html="text"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  isVisible: Boolean,
  title: String,
  text: String,
});

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  
  max-height: 80vh; /* Ensure it doesn’t exceed 80% of the viewport height */
  overflow-y: auto; /* Enable scrolling inside the modal */
  text-align: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
}

.modal-title {
  margin-bottom: 10px;
}

.modal-body {
  max-height: 60vh; /* Prevent content overflow */
  overflow-y: auto; /* Scrollable content */
}

.modal-text {
  color: #333;
  font-size: 25px;
}
</style>
